import { render, staticRenderFns } from "./TheMiniTextIcon.vue?vue&type=template&id=4ed82bcd&scoped=true&"
import script from "./TheMiniTextIcon.vue?vue&type=script&lang=js&"
export * from "./TheMiniTextIcon.vue?vue&type=script&lang=js&"
import style0 from "./TheMiniTextIcon.vue?vue&type=style&index=0&id=4ed82bcd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed82bcd",
  null
  
)

export default component.exports